import Class from "./Class";

export default class Subject {
    id: number;
    facultyID: number;
    code: string;
    bosCode: string;
    name: string;
    description: string;
    noOfSubgrids: number;
    unitValue: number;
    load: number;
    maxClassSize: number;
    gender: string;
    allowGenderBreaches: boolean;
    allowPrerequisiteBreaches: boolean;
    yearLevel: string;
    codeGenScheme: number;
    orderNo: number;

    instances: number;

    classes: Class[];

    get display() {
        return this.name;
    }

    constructor(data?: Partial<Subject>) {
        Object.assign(this, data);

        this.instances = this.classes ? this.classes.length : 0;
    }
}
